import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UpsertExternalConnectionPayload, DeleteByIdPayload, ExternalConnectionModel } from '../../gql-types.generated';
import { RootState } from '../../store';

interface SliceState {
    error?: Error;
    externalConnectionList?: ExternalConnectionModel[];
    upsertExternalConnectionStatus?: UpsertExternalConnectionPayload;
    deleteExternalConnectionStatus?: DeleteByIdPayload;
}

const initialState: SliceState = {
    error: undefined,
    externalConnectionList: undefined,
    upsertExternalConnectionStatus: undefined,
    deleteExternalConnectionStatus: undefined
};

export const slice = createSlice({
    name: 'externalConnections',
    initialState,
    reducers: {
        fetchError: (state, action: PayloadAction<Error>) => {
            // eslint-disable-next-line no-param-reassign
            state.error = action.payload;
        },

        clearError: state => {
            // eslint-disable-next-line no-param-reassign
            state.error = undefined;
        },

        clearState: state => {
            // eslint-disable-next-line no-param-reassign
            state.error = undefined;
            // eslint-disable-next-line no-param-reassign
            state.externalConnectionList = undefined;
            // eslint-disable-next-line no-param-reassign
            state.upsertExternalConnectionStatus = undefined;
            // eslint-disable-next-line no-param-reassign
            state.deleteExternalConnectionStatus = undefined;
        },

        fetchExternalConnectionListSuccess: (state, action: PayloadAction<ExternalConnectionModel[]>) => {
            // eslint-disable-next-line no-param-reassign
            state.externalConnectionList = action.payload;
        },

        captureUpsertExternalConnectionStatus: (state, action: PayloadAction<UpsertExternalConnectionPayload | undefined>) => {
            // eslint-disable-next-line no-param-reassign
            state.upsertExternalConnectionStatus = action.payload;
        },

        captureDeleteExternalConnectionStatus: (state, action: PayloadAction<DeleteByIdPayload | undefined>) => {
            // eslint-disable-next-line no-param-reassign
            state.deleteExternalConnectionStatus = action.payload;
        }
    }
});

export const selectExternalConnectionError = (state: RootState): Error | undefined => state.externalConnections.error;
export const selectExternalConnectionList = (state: RootState): ExternalConnectionModel[] | undefined => state.externalConnections.externalConnectionList;
export const selectUpsertExternalConnectionStatus = (state: RootState): UpsertExternalConnectionPayload | undefined => state.externalConnections.upsertExternalConnectionStatus;
export const selectDeleteExternalConnectionStatus = (state: RootState): DeleteByIdPayload | undefined => state.externalConnections.deleteExternalConnectionStatus;

export const {
    clearError,
    fetchError,
    fetchExternalConnectionListSuccess,
    captureUpsertExternalConnectionStatus,
    captureDeleteExternalConnectionStatus,
    clearState
} = slice.actions;

export default slice.reducer;
